module.exports = __webpack_public_path__ + "static/media/micro375.4c1faa73.jpg";